import { colors } from "../colors";

let calibrationPlotOptions = (theme) => ({
  chart: {
    type: "line",
    animation: true,
    backgroundColor: null,
    margin: 1,
    zoomType: "x",
  },
  credits: {
    enabled: false,
  },
  boost: {
    enabled: false, // enable animation
    useGPUTranslations: true,
    seriesThreshold: 0,
  },
  title: {
    text: undefined,
  },
  yAxis: {
    title: {},
    labels: {
      enabled: false,
      format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    tickWidth: 0,
    gridLineWidth: 0,
    minorGridLineWidth: 0,
  },
  xAxis: {
    title: {
      enabled: false,
      text: "z (mm)",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    labels: {
      y: -8, // move numbers up
      style: {
        color: colors.chartAxisLabel,
      },
    },
    tickInterval: 2,
    lineWidth: 0,
    tickLength: 5,
    tickPosition: "inside",
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      name: "Calibration Data",
      lineWidth: 2,
      color: colors[theme].primary,
      borderWidth: 0,
      nullColor: colors[theme].primary,
      enableMouseTracking: false,
    },
    {
      name: "Depth Line",
      color: colors.calibrationPlot,
      enableMouseTracking: false, // disable tootip
      tooltip: {
        headerFormat: undefined,
        pointFormat: "Depth Line: {point.x:%0.2f} mm",
      },
    },
  ],
});

export { calibrationPlotOptions };
